import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { TitleLarge, SubtitleMedium } from '../components/Typography';
import { colors } from '../theme/tokens';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/Button';

const CommunityContainer = styled.div`
  min-height: 100vh;
  padding: 1rem;
  overflow-y: auto;
`;

const CommunityHeader = styled.div`
  background-color: ${colors.neutral.white};
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleSection = styled.div``;

const CommunityTitle = styled(TitleLarge)`
  color: ${colors.neutral.black};
  margin-bottom: 1rem;
`;

const ContentContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
`;

export default function Community() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <CommunityContainer>
      <CommunityHeader>
        <HeaderContent>
          <TitleSection>
            <CommunityTitle>Community</CommunityTitle>
            <SubtitleMedium>Connect with other food enthusiasts and share your culinary journey</SubtitleMedium>
          </TitleSection>
          <Button>Create Post</Button>
        </HeaderContent>
      </CommunityHeader>
      <ContentContainer>
        <div>Community features coming soon...</div>
      </ContentContainer>
    </CommunityContainer>
  );
} 